module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/chart-bar-1-fb2fdb0558a66bdc952c60702769019f.svg";